/**
 * Resolve `path` on the docs portal of the environment the app runs in. Every
 * portal publishes it as `docs.<env>` beside `backstage.<env>`. Undefined when
 * the app host is not a portal host (local dev), so callers render no link
 * rather than one into another environment.
 */
export function docsPortalUrl(
  appBaseUrl: string | undefined,
  path: string,
): string | undefined {
  if (!appBaseUrl) return undefined;
  let app: URL;
  try {
    app = new URL(appBaseUrl);
  } catch {
    return undefined;
  }
  if (!app.hostname.startsWith('backstage.')) return undefined;
  const docs = `${app.protocol}//docs.${app.hostname.slice(
    'backstage.'.length,
  )}`;
  return new URL(path, docs).toString();
}
